/**
 * Created by mac on 12/23/20
 */

const MonsterView = function (component, unitView) {
    this.unitView = unitView;
};

MonsterView.prototype.onDie = function () {
    this.unitView.sprite.setAnimation(0, "die", false);
    this.unitView.sprite.setCompleteListener(() => {
        this.unitView.removeFromParent();
    });
    this.unitView.sprite.setSafeToRemove();
    cleverapps.effects.fire("monster.die");
};

MonsterView.prototype.onSpawn = function (delay) {
    this.unitView.hideAdditionalViews();
    this.unitView.sprite.stopAllActions();
    this.unitView.sprite.setVisible(false);

    this.unitView.sprite.runAction(new cc.Sequence(
        new cc.DelayTime(delay || 0),
        new cc.Show(),
        new cc.CallFunc(() => {
            this.unitView.sprite.setAnimationAndIdleAfter("show_up", "idle");
            if (this.unitView.unit.stage === 2) {
                cleverapps.effects.fire("monster.head.spawn");
            } else {
                cleverapps.effects.fire("monster.tentacles.spawn");
            }
        })
    ));
};

MonsterView.prototype.onBattle = function () {
    const sprite = this.unitView.sprite;

    const loading = sprite instanceof LazyAsset && !sprite.isLoaded();
    if (!loading && sprite.hasAnimation("battle")) {
        sprite.setAnimationAndIdleAfter("battle", "idle");
    }
    cleverapps.effects.fire(`monster.push.${this.unitView.unit.stage}`);
};

MonsterView.prototype.getBattleAnimationDuration = function () {
    const animation = this.unitView.sprite.getAnimationData("battle");

    return animation && animation.duration || 0;
};